import React from 'react';
import ModernNode from './ModernNode';
import { NODE_TYPES } from '../../config/nodeConfig';

const InputNode = (props) => {
  return <ModernNode {...props} nodeType={NODE_TYPES.INPUT} />;
};

export default InputNode;